<template>
  <div :class="{'home': header == 'on'}">
    <van-nav-bar id="home-nav" :fixed="true" :title="$t('Track a flight')" :z-index="10000" v-if="header == 'on'"
                 @click-left="onClickLeft" :left-arrow="true"/>
    <van-nav-bar
      left-arrow
      @click-left="onClickLeft"
      class="no-header"
      v-if="header !== 'on'"
    />
    <div class="header">
      <span v-if="searchType === 'flightNumber'" class="gray-text">{{ searchProps.fnum }}</span>
      <span v-if="searchType === 'route'" class="gray-text">{{ $t('From') }}</span>
      <span v-if="searchType === 'route'" class="black-text">{{ searchProps.from }}</span>
      <span v-if="searchType === 'route'" class="gray-text">{{ $t('To') }}</span>
      <span v-if="searchType === 'route'" class="black-text">{{ searchProps.to }}</span>
      <span class="black-text">-{{ searchProps.date }}</span>
      <span v-if="searchType === 'route'" class="black-text">-{{ searchProps.time }}</span>
    </div>
    <flight-list :flight-list="flightList" from="number"></flight-list>
  </div>
</template>

<script>
import FlightList from '../components/FlightList'
import { NavBar } from 'vant';

export default {
  name: 'FlightNumber',
  components: {
    FlightList,
  },
  data () {
    return {
      flightList: [],
      header: sessionStorage.getItem('header'),
      searchType: sessionStorage.getItem('searchType'),
      searchProps: JSON.parse(sessionStorage.getItem('searchProps'))
    }
  },
  created () {
    this.flightList = JSON.parse(sessionStorage.getItem('flightList')).sort((a, b) => {
      return (new Date(a.FlightDeptimePlanDate.replace(/-/g, '/')).getTime()) - (new Date(b.FlightDeptimePlanDate.replace(/-/g, '/')).getTime())
    })
  },
  methods: {
    onClickLeft() {
      this.$destroy()
      let lang = localStorage.getItem('cod_lang') || localStorage.getItem('lang')
      if (localStorage.getItem('cid')) {
        this.$router.push(`/?lang=${lang}&cid=${localStorage.getItem('cid')}`)
      } else {
        this.$router.push(`/?lang=${lang}`)
      }
    }
  }
}
</script>

<style scoped>
.home {
  padding-top: 60px;
}

#app .no-header {
  background: #fff
}

#app .no-header .van-icon {
  color: #999;
}

.header {
  padding: 0 0 10px 5px;
  overflow: hidden;
}

.header span {
  padding: 0 2px;
  float: left;
}

.header .gray-text {
  font-size: 16px;
  color: #888;
}

.header .black-text {
  font-size: 16px;
  color: #333;
  font-weight: 600;
}
</style>
